import React from 'react'
import Box from '@mui/material/Box'

import { ActionCardProps } from 'types/TextAnalysis'

const CardMetrics = React.memo(function CardMetrics({
  cardMetrics,
}: ActionCardProps) {
  if (!cardMetrics) return <></>
  return (
    <Box m="0 !important" pt="1rem" data-testid="card-metrics">
      {cardMetrics}
    </Box>
  )
})

export { CardMetrics }
